export default __webpack_public_path__ + "8d7abc03ff1e5ee948c6f272be9714cc.png";